import {ErrorModel} from '../../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../../root';
const FUNCTION_CODE = 'GET_ALL_DASHBOARD_CONSULTANT_WORKLOAD';

export async function getAllWorkload(userToken: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/consultant/workload/`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
